import { createTheme } from "@mui/material/styles";
import LoadingButton from "@mui/lab/LoadingButton";

const textColor = "#002B44";

const theme = createTheme({
  palette: {
    primary: {
      lighter: "#214d66",
      main: "#07192D",
      300: "#0B2A41",
      contrastText: "white",
    },
    secondary: {
      main: "#c8d5e3",
      300: "#bad6f5",
      400: "#97c2f0",
      contrastText: "#0782C3",
      typePropertySpan: "#E1EEFD",
    },
    text: {
      primary: textColor,
      textPropProject: "#003366",
      footerColor: "#BDDDFA",
    },
    background: {
      default: "#F3F4F6",
      paper: "#FFFFFF",
    },
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
    color: "#260944",
  },
  components: {
    MuiContainer: {
      defaultProps: {
        maxWidth: "xl",
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: "black",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          input: {
            fontWeight: 400,
          },
          label: {
            fontWeight: 500,
            color: "#a7a7a7bd!important",
          },
          "& .Mui-disabled": {
            "-webkit-text-fill-color": "#a7a7a7bd!important",
            color: "#a7a7a7bd!important",
            fontWeight: 400,
          },
          fieldset: {
            borderColor: "#b0b0b0d9",
          },
          "input::placeholder": {
            color: "#2e2e2e",
          },
          "& .MuiInput-root::before": {
            // borderBottom: "1px solid #fff"
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#002B44",
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          zIndex: 2000,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: "1px 1px 6px -3px #898989",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "#9eb2b38a!important",
        },
      },
      defaultProps: {
        variant: "fullWidth",
      },
    },
    MuiBadge: {
      styleOverrides: {
        badge: {
          fontWeight: "600!important",
        },
      },
    },
    MuiAlert: {
      variants: [
        {
          props: { severity: "error" },
          style: {
            backgroundColor: "rgb(255 184 184 / 100%)",
            fontWeight: 500,
            svg: {
              color: "#dd0000",
            },
          },
        },
        {
          props: { severity: "success" },
          style: {
            backgroundColor: "rgb(177 247 177 / 100%)",
            fontWeight: 500,
            svg: {
              color: "#00a31d",
            },
          },
        },
      ],
    },
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       textTransform: "none",
    //       fontWeight: 500,
    //       paddingTop: "13px",
    //       paddingBottom: "13px",
    //       fontSize: "0.938rem",
    //     },
    //   },
    //   defaultProps: {
    //     variant: "contained",
    //   },
    //   variants: [
    //     {
    //       props: { variant: "contained" },
    //       style: {
    //         color: "#fff",
    //       },
    //     },
    //   ],
    // },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
      variants: [
        {
          props: { className: "link" },
          style: {
            cursor: "pointer",
            textDecoration: "underline",
            transition: "color 0.3s ease",
            ":hover": {
              color: "#999999",
            },
          },
        },
      ],
    },
    MuiLoadingButton: {
      defaultProps: {
        variant: "contained",
      },
    },
  },
});

export default theme;
